import { get } from 'lodash';

class BackgroundProcessModel {
  static initialFilters(filters) {
    return {
      type: filters?.type || null,
      serviceType: filters?.serviceType || null,
      statuses: filters?.statuses?.map((el) => el.value) || [],
      statusDescriptions: filters?.statusDescriptions?.map((el) => el.value) || [],
      username: filters?.username || '',
      limit: filters?.limit || 50,
      offset: filters?.offset || 0,
    };
  }

  static parseRequestSearch(filters) {
    return {
      type: filters?.type,
      serviceType: filters?.serviceType,
      statuses: filters?.statuses?.map((el) => el.value) || [],
      statusDescriptions: filters?.statusDescriptions?.map((el) => el.value) || [],
      username: filters?.username,
      offset: filters?.offset,
      limit: filters?.limit,
    };
  }

  static hasRunningProcess(listProcess) {
    return (
      listProcess.some((process) => process.status === 'RUNNING') ||
      listProcess.some((process) => process.statusDescription === 'MAINTAIN')
    );
  }

  static isProcessCompleted(process) {
    const status = get(process, 'status');
    const statusDescription = get(process, 'statusDescription');
    return status === 'COMPLETED' && statusDescription === 'SUCCESSFUL';
  }
}

export default BackgroundProcessModel;
